import { useEffect, useState } from 'react';

export const useThirdPartyScript = (scriptUrl, scriptId, async, type) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!scriptUrl) {
      setIsLoaded(false);
      return;
    }

    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      setIsLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.id = scriptId;
    script.async = async;
    script.type = type;

    const handleLoad = () => setIsLoaded(true);
    const handleError = (err) => {
        setError(err);
        script.remove();
    }

    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);

    document.head.appendChild(script);

    return () => {
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);
      if (document.getElementById(scriptId)) document.head.removeChild(script);
    };
  }, [scriptUrl, scriptId]);

  return { isLoaded, error };
};